import { LottiePlayer } from '@repo/ui';
import { AuthGuard } from '@repo/user-session';
import { Button } from '@zenterprise-inc/ui';
import { GetServerSideProps } from 'next';
import { useRouter } from 'next/router';
import { ReactElement } from 'react';

import s from '@/components/error/NotWorkingHour.module.scss';
import Layout from '@/components/layout/Layout';

export const getServerSideProps = (async ({ query }) => {
  return {
    props: {
      isAgreedMarketingTerm: query?.agreement === 'true'
    }
  };
}) satisfies GetServerSideProps;

function HometaxNotWorkingHourErrorPage({ isAgreedMarketingTerm }: { isAgreedMarketingTerm: boolean }) {
  const router = useRouter();

  return (
    <Layout leftIcon={{ icon: 'back' }} className={s.next_child_div}>
      <section className={s.contents}>
        <LottiePlayer src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/refund/lotties/ani_bell-dot.json`} className={s.lottie} />
        <h1 className={s.title}>
          홈택스 점검(오전 0시~6시)으로
          <br />
          환급금 조회가 어려워요
        </h1>
        {isAgreedMarketingTerm ? (
          <p className={s.description}>
            점검이 끝나면 카카오톡 알림톡으로
            <br />
            빠르게 알려드릴게요.
          </p>
        ) : (
          <div className={s.term_section}>
            <p className={s.description}>
              조회할 수 있을 때 알려드릴 수 있어요.
              <br />
              알림을 받으시겠어요?
            </p>
            <Button.Box
              type={'button'}
              size={'large'}
              state={'primary'}
              className={s.agree_btn}
              onClick={() => router.push({ pathname: '/my/notification', query: router.query })}
            >
              알림받기 설정
            </Button.Box>
          </div>
        )}
      </section>
    </Layout>
  );
}

HometaxNotWorkingHourErrorPage.getLayout = (page: ReactElement) => <AuthGuard>{page}</AuthGuard>;

export default HometaxNotWorkingHourErrorPage;
